'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _createBrowserHistory = require('history/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _tinymce = require('tinymce/tinymce');

var _tinymce2 = _interopRequireDefault(_tinymce);

require('tinymce/themes/modern/theme');

require('tinymce/plugins/code');

require('tinymce/plugins/print');

require('tinymce/plugins/preview');

require('tinymce/plugins/fullpage');

require('tinymce/plugins/searchreplace');

require('tinymce/plugins/autolink');

require('tinymce/plugins/directionality');

require('tinymce/plugins/visualblocks');

require('tinymce/plugins/visualchars');

require('tinymce/plugins/fullscreen');

require('tinymce/plugins/image');

require('tinymce/plugins/link');

require('tinymce/plugins/media');

require('tinymce/plugins/table');

require('tinymce/plugins/charmap');

require('tinymce/plugins/hr');

require('tinymce/plugins/pagebreak');

require('tinymce/plugins/nonbreaking');

require('tinymce/plugins/anchor');

require('tinymce/plugins/toc');

require('tinymce/plugins/insertdatetime');

require('tinymce/plugins/advlist');

require('tinymce/plugins/lists');

require('tinymce/plugins/textcolor');

require('tinymce/plugins/wordcount');

require('tinymce/plugins/imagetools');

require('tinymce/plugins/contextmenu');

require('tinymce/plugins/colorpicker');

require('tinymce/plugins/textpattern');

require('tinymce/plugins/help');

require('tinymce/plugins/paste');

require('normalize.css/normalize.css');

require('react-table/react-table.css');

require('react-select/dist/react-select.css');

require('video-react/dist/video-react.css');

require('tinymce-aws-s3-upload-plugin/dist/tinymce-aws-s3-upload-plugin.min.js');

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

var _MuiThemeProvider = require('material-ui/styles/MuiThemeProvider');

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _configureStore = require('./store/configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

var _api = require('./api');

var _firebase = require('./firebase/firebase');

var _auth = require('./actions/auth');

var _App = require('./App');

var _App2 = _interopRequireDefault(_App);

require('./styles/styles.css');

require('antd/dist/antd.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global.AWS = _awsSdk2.default; //AWS tem que ser global para a lib de upload de imagem para o s3 do tinymce usar o aws.
global.tinymce = _tinymce2.default; //tinymce tem que ser global para a lib do tinymce-react conseguir acesso.
global.tinymce.init({
    selector: '#tiny',
    plugins: ['code', 'print', 'preview', 'fullpage', 'searchreplace', 'autolink', 'directionality', 'visualblocks', 'visualchars', 'fullscreen', 'image', 'link', 'media', 'table', 'charmap', 'hr', 'pagebreak', 'nonbreaking', 'anchor', 'toc', 'insertdatetime', 'advlist', 'lists', 'textcolor', 'wordcount', 'imagetools', 'contextmenu', 'colorpicker', 'textpattern', 'help', 'paste']
});

var store = (0, _configureStore2.default)();

var history = (0, _createBrowserHistory2.default)();

var renderApp = function renderApp() {
    _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_App2.default, { history: history })
    ), document.getElementById('root'));
};

_reactDom2.default.render(_react2.default.createElement(
    _MuiThemeProvider2.default,
    null,
    _react2.default.createElement(
        'div',
        { style: { textAlign: 'center' } },
        _react2.default.createElement(_CircularProgress2.default, { size: 60 })
    )
), document.getElementById('root'));

if (env.SKIP_AUTH === 'true') {
    (0, _api.requestUnprotectedRoute)('post', '/signInLocal').then(function (response) {
        localStorage.setItem('authToken', response.data.token);
        store.dispatch(_auth.actionCreators.loginSuccess(response.data.email));
        renderApp();
    }).catch(function () {
        localStorage.removeItem('authToken');
        history.push('/login');
        renderApp();
    });
} else {
    var unsubscribeAuthStateChange = _firebase.firebase.auth().onAuthStateChanged(function (user) {
        unsubscribeAuthStateChange(); // Run this logic only when starting the application

        var authToken = localStorage.getItem('authToken');
        if (user && authToken && authToken.length > 0) {
            store.dispatch(_auth.actionCreators.loginSuccess(user.email));
            renderApp();
        } else {
            store.dispatch(_auth.actionCreators.logoutRequest());
            history.push('/login');
            renderApp();
        }
    });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/index.js
// module id = 1521
// module chunks = 0